
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-03-11-uptrain-try-it-out",
      function () {
        return require("private-next-pages/blogs/2023-03-11-uptrain-try-it-out/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-03-11-uptrain-try-it-out"])
      });
    }
  